import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import QuoteView from '../quoteView';
import { formatPrice } from '../../../quotes/priceFormatter';
import classNames from 'classnames';
import {
  getMsrpColumnClassNames,
  getDNetColumnClassNames,
} from '../../../quotes/quotePriceMode';

const NoInstallation = ({ show }) => {
  if (!show) return null;
  return (
    <div className="text-center">
      This quote does not have installation configured
    </div>
  );
};

const InstallationOption = ({
  option,
  msrpClassNames,
  dNetClassNames,
  isMsrpOnly,
  isoCurrencySymbol,
}) => (
  <tr>
    <td data-title="" className="text-start">
      {option.name}
      {option.partNumber && (
        <Fragment>
          <br />
          {option.partNumber}
        </Fragment>
      )}
      {option.description && (
        <Fragment>
          <div className="mt-2 text-break-line">{option.description}</div>
        </Fragment>
      )}
    </td>
    <td className="price-breakdown">
      <div className="row price-heading-mobile">
        <div className="col-6"></div>
        <div className={classNames('price-heading', msrpClassNames)}>MSRP</div>
        <div className={classNames('price-heading', dNetClassNames)}>
          D. NET
        </div>
      </div>
      {option.price && (
        <Fragment>
          {option.discountPercentage > 0 && !isMsrpOnly && (
            <div className="row">
              <div className="col-6">Base price</div>
              <div className={msrpClassNames}>{formatPrice(option.msrp)}</div>
              <div className={dNetClassNames}>{formatPrice(option.price)}</div>
            </div>
          )}
          {option.discountPercentage > 0 && !isMsrpOnly && (
            <div className="row">
              <div className="col-6">{`Dealer Discount (${option.discountPercentage}%)`}</div>
              <div className={msrpClassNames}>N/A</div>
              <div className={dNetClassNames}>
                {formatPrice(option.discount * -1)}
              </div>
            </div>
          )}
          <div className="row unit-price">
            <div className="col-6">Unit Price</div>
            <div className={msrpClassNames}>{formatPrice(option.unitMsrp)}</div>
            <div className={dNetClassNames}>
              {formatPrice(option.unitPrice)}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Quantity</div>
            <div className="col-3 text-center">{option.quantity}</div>
          </div>
        </Fragment>
      )}
      <div className="row total-price">
        <div className="col-6">
          {option.price ? 'Total' : 'Travel Charge'} ({isoCurrencySymbol})
        </div>
        <div className={msrpClassNames}>{formatPrice(option.totalMsrp)}</div>
        <div className={dNetClassNames}>{formatPrice(option.total)}</div>
      </div>
    </td>
  </tr>
);

const InstallationOptions = ({
  installationOptions,
  show,
  msrpClassNames,
  dNetClassNames,
  isMsrpOnly,
  isoCurrencySymbol,
}) => {
  if (!show) return null;

  return (
    <table className="table quote-view-table quote-view-products-table table-mobile">
      <thead>
        <tr>
          <th width="60%" className="text-start">
            Description
          </th>
          <th width="40%">
            <div className="row">
              <div className="col-6"></div>
              <div className={classNames(msrpClassNames, 'text-end')}>MSRP</div>
              <div className={classNames(dNetClassNames, 'text-end')}>
                D. NET
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {installationOptions.map((option, i) => (
          <InstallationOption
            key={i}
            option={option}
            msrpClassNames={msrpClassNames}
            dNetClassNames={dNetClassNames}
            isMsrpOnly={isMsrpOnly}
            isoCurrencySymbol={isoCurrencySymbol}
          />
        ))}
      </tbody>
    </table>
  );
};

export default class QuoteInstallationComponent extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
  };

  render() {
    const { installationOptions, isoCurrencySymbol } = this.props.quote;
    const { selectedPriceMode } = this.props;
    const installationIncluded = installationOptions.length > 0;

    const msrpClassNames = getMsrpColumnClassNames(selectedPriceMode);
    const dNetClassNames = getDNetColumnClassNames(selectedPriceMode);
    const isMsrpOnly = selectedPriceMode === 'msrpOnly';

    return (
      <div className="card mb-3 box-shadow">
        <div className="card-body">
          <h6 className="card-title text-center">Installation</h6>
          <NoInstallation show={!installationIncluded} />
          <InstallationOptions
            installationOptions={installationOptions}
            show={installationIncluded}
            msrpClassNames={msrpClassNames}
            dNetClassNames={dNetClassNames}
            isMsrpOnly={isMsrpOnly}
            isoCurrencySymbol={isoCurrencySymbol}
          />
        </div>
      </div>
    );
  }
}
